import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { CommonNotificationSaveError, CommonNotificationSaveSuccessFully } from '@shares/CommonNotification';
import { get } from 'lodash';
import { useAsyncFn } from 'react-use';
import { BIGDATA_CONSTANT } from '../../../../../common/constant';
import AddTagDefinition from './api';
import { TPayloadSaveTermPangoConfig } from './type';

export type TUseSaveTermPangoConfig = {
  isLoading?: boolean;
  response?: any;
  handleSaveTermPangoConfig: (payload: TPayloadSaveTermPangoConfig) => Promise<any | undefined>;
};

const useSaveTermPangoConfig = (): TUseSaveTermPangoConfig => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async (payload: TPayloadSaveTermPangoConfig) => {
    if (!payload) return;
    const response: Promise<any> = await commonActionFromDALV2(AddTagDefinition, payload);
    const result = await response;
    if (result.success) CommonNotificationSaveSuccessFully(BIGDATA_CONSTANT.message.notification.success.saved);
    else CommonNotificationSaveError(get(result, 'message', 'Somethings Went Wrong!'));
    return result;
  }, []);

  return {
    response: state?.value,
    handleSaveTermPangoConfig: doFetch,
    isLoading: state.loading,
  };
};

export default useSaveTermPangoConfig;
